import React from "react";
import { useTheme } from "@mui/material";
import { Modal, ModalProps } from "@rentablo/components";

interface TooltipModalProps extends ModalProps {
  anchorPosition?: {
    top?: number | string;
    right?: number | string;
    bottom?: number | string;
    left?: number | string;
  };
}

export const TooltipModal = ({
  anchorPosition = { top: "-32px", right: "24px" },
  outerSx,
  ...modalProps
}: TooltipModalProps) => {
  const theme = useTheme();
  const { top, right, bottom, left } = anchorPosition;

  return (
    <Modal
      position="bottom"
      backdropStyle="blur"
      disableScrollLock
      disablePortal
      interactiveBackground
      backgroundColor={theme.palette.background.subtle}
      boxShadow="0px 2px 4px -1px #1E273229"
      borderRadius="6px"
      outerSx={{
        top: top ? `${top}!important` : undefined,
        right: right ? `${right}!important` : undefined,
        bottom: bottom ? `${bottom}!important` : undefined,
        left: left ? `${left}!important` : undefined,
        ...outerSx,
      }}
      {...modalProps}
    />
  );
};
